import { render, staticRenderFns } from "./crudProducts.vue?vue&type=template&id=2249f961&"
import script from "./crudProducts.vue?vue&type=script&lang=js&"
export * from "./crudProducts.vue?vue&type=script&lang=js&"
import style0 from "./crudProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports